import React, { useState } from 'react';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const CopyToClipboardIcon = ({ textToCopy, size = '14' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!textToCopy) return;
    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <OverlayTrigger delay={{ show: 100, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">{copied ? '¡Copiado!' : 'Copiar'}</Tooltip>}>
      <span
        className="d-inline-block"
        onClick={handleCopy}
        style={{ transform: 'translate(2px)', backgroundColor: copied ? '#d4edda' : '#f0f0f0', borderRadius: '50%', padding: '1px 4px' }}
      >
        <CsLineIcons icon={copied ? 'check' : 'duplicate'} size={size} className={`cursor-pointer mb-0 ${copied ? 'text-success' : 'text-muted'}`} />
      </span>
    </OverlayTrigger>
  );
};

export default CopyToClipboardIcon;
